export default __webpack_public_path__ + "static/media/blessedblade.db6d28f2.png";